<template>
    <v-container class="text-center">
        <p class="h2">{{mensajeValidacion}}</p>
    </v-container>
</template>
<script>
import axios from 'axios'
export default {
    name:'token',
    props:{
        tokenImplicit: null,
        urlClientId:null,
        urlSecretClient:null,
        
    },

    methods:{
        async me(t){
            let token = t
            if(this.tokenImplicit!=null){
                token = this.tokenImplicit
            }
            console.log('Token validate: '+t)
            //https://esmtgenesysauth.jakiodes.com/
            await axios.get('https://esmtgenesysauth.esmtcx.solutions/genesysme.php?theT='+token, {
                    headers:{
                        /*'Authorization': 'Bearer '+this.tokenGC, 
                        'Access-Control-Allow-Origin': '*',
                        'Accept': '*',
                        'Content-Type': 'application/json'*/
                    }
                    }).then(response => {
                        console.log('Credential validation in progress')

                        if(response.data.message!=null){
                            console.log(response.data.message)
                            this.tokenActive = false
                            //return 'No validate'
                        }else{
                            console.log(response.data)
                            this.tokenActive = true
                        }
                        //return true
                    }).catch(error => {
                        console.log('Credential validation in progress')
                        console.log(error)
                        this.tokenActive = false
                        //return 'Error Network'
                        //return false

                    })
        },

        lsExist(){
            let exist = localStorage.getItem('esmtAppT160')

            if(exist!=null){
                console.log('LS session exist')
                this.localStorageExist = true
            }
        },
    },
    data() {
        return {
            tokenActive: null,
            localStorageExist: null,
            mensajeValidacion: 'Validando Organización, por favor espere...'
        }
    },
    watch:{
      tokenActive: function(newValue) {

                if(newValue!=null){
                  if(newValue == true){
                        this.$router.push({ name: 'App' })
                    }else{
                        this.$router.push({ name: 'Auth' })
                    }
                }else{
                    this.mensajeValidacion = 'No se ha podido validar la App, intentalo nuevamente o contacta con el administrador.'
                }

      },
              
    },
    mounted(){

        if(this.tokenImplicit!=null){
            this.me(theAppLocal.t)
        }
          
        let theAppLocal = {}

        if((localStorage.getItem('esmtAppT160')==null || localStorage.getItem('esmtAppT160')=='null' ||  localStorage.getItem('esmtAppT160')=='') || (this.urlClientId!=null && this.urlSecretClient!=null)){
            this.$router.push({ name: 'Auth' })
        }else{

                theAppLocal = JSON.parse(localStorage.getItem('esmtAppT160'))
                
                this.lsExist()

                if(this.localStorageExist){
                    this.me(theAppLocal.t)
                }else{
                    this.auth = false
                    this.$router.push({ name: 'Auth' })
                }
   

        }
    }
}
</script>